export const VITALY_PARTNER_CODE = 'vitaly';

/**
 * Checks if the current implementation is for the Vitaly service, checking for partner or if page is inside an <iframe> tag.
 *
 * @returns {boolean} Returns true if the implementation is for Vitaly, false otherwise.
 */
export const isVitalyImplementation = (searchString?: string | null) => {
  // Check queryParams from SSR
  if (searchString) {
    const urlParams = new URLSearchParams(searchString);
    const integrationParam = urlParams.get('integration');
    return integrationParam === VITALY_PARTNER_CODE;
  }

  if (typeof window === 'undefined') return false;

  const urlParams = new URLSearchParams(window.location.search);
  const integrationParam = urlParams.get('integration');
  return integrationParam === VITALY_PARTNER_CODE || localStorage.getItem('partner') === VITALY_PARTNER_CODE;
};
